import { render, staticRenderFns } from "./BookmarkTab.vue?vue&type=template&id=be2099ca&scoped=true"
import script from "./BookmarkTab.vue?vue&type=script&lang=js"
export * from "./BookmarkTab.vue?vue&type=script&lang=js"
import style0 from "./BookmarkTab.vue?vue&type=style&index=0&id=be2099ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2099ca",
  null
  
)

export default component.exports